export default __webpack_public_path__ + "static/media/pt.96475126.svg";